/**
 * @file: useAppSharing.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useAppLoading } from '@euler/components/loading/Provider';
import { AppSharingInfo } from '@euler/model';
import { useServiceFactory } from '@euler/services/factory';
import { showAlert } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import { useState } from 'react';

export const useAppSharing = () => {
  const [appSharingInfo, setAppSharingInfo] = useState<AppSharingInfo>();
  const { supportService } = useServiceFactory();
  const appLoading = useAppLoading();

  const prepareAppSharingInfo = usePersistFn(async () => {
    if (appSharingInfo == null) {
      try {
        appLoading.show();
        const sharingInfo = await supportService.getAppSharingInfo();
        setAppSharingInfo(sharingInfo);
        return sharingInfo;
      } catch (e) {
        void showAlert('出错了', (e as Error).message);
      } finally {
        appLoading.hide();
      }
    }
    return appSharingInfo;
  });

  return { appSharingInfo, prepareAppSharingInfo };
};
